(function(){
    angular
        .module('appback')
        .directive('ngOperacionmat', ngOperacionmat);

        ngOperacionmat.$inject = ['$timeout','ResultadosService'];
        function ngOperacionmat($timeout,ResultadosService){
            return {
	            require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=operacionmat.twig',
	            scope: {
                  //ngModel : '=',
                  item: '=',
                  peticion: '='
              	},
	            link: function(scope, element, attrs, ngModel) {
	            	 return $timeout(function () {
	            	 	//console.log("opmat item",scope.peticion);

	            	 	scope.analiticasOperaciones = {};

	            	 	scope.addbits = function(str) {
						  return Function(`'use strict'; return (${str})`)()
						}
	            	 	scope.generarWatches = function(){
	            	 		angular.forEach(scope.analiticasOperaciones, function(value, key) {
		            	 		scope.$watch('peticion.analiticas['+value.cont+'].resultado.resultado',function(newvalue,oldvalue){
		            	 			var operacionResp = scope.item.analitica.operacionmat;
		            	 			var res = true;
		            	 			for(var cont=0;cont<scope.devolucion.keys.length;cont++){
		            	 				//console.log("codigo alfa",scope.analiticasOperaciones[scope.devolucion.keys[cont]]);
		            	 				if(typeof(scope.analiticasOperaciones[scope.devolucion.keys[cont]].res.resultado.resultado) != 'undefined' && scope.analiticasOperaciones[scope.devolucion.keys[cont]].res.resultado.resultado){
											operacionResp = operacionResp.replace("{"+scope.devolucion.keys[cont]+"}",scope.analiticasOperaciones[scope.devolucion.keys[cont]].res.resultado.resultado);
										}else{
											res = false;
										}
		            	 			}
		            	 			if(res){
		  		            			//console.log("cambiamos operacion res",operacionResp);
		  		            			//console.log("cambiamos operacion res",scope.addbits(operacionResp));
		            	 				ngModel.$setViewValue(scope.addbits(operacionResp).toFixed(2));
	                					ngModel.$render();
		            	 				//CAMBIAMOS EL NGMODEL DELA OPERACION MAT
		            	 			}
		            	 			
		  		            		//console.log("operacion mat", scope.item.analitica.operacionmat);
			            		},true)
		            	 	});
	            	 	}

	            	 	scope.buscarAnalitica = function(codigo_alfa){
	            	 		var res = false;
	            	 		for(var cont=0;cont<scope.peticion.analiticas.length && !res;cont++){
	            	 			if(scope.peticion.analiticas[cont].analitica.codigo_alfa==codigo_alfa){
	            	 				//res = cont;
	            	 				scope.analiticasOperaciones[codigo_alfa] = {cont:cont,res:scope.peticion.analiticas[cont]};
	            	 			}
	            	 		}
	            	 		return res;
	            	 	}

	            	 	scope.revisarKeys = function(keys){
	            	 		for(var cont=0;cont<keys.length;cont++){
	            	 			scope.buscarAnalitica(keys[cont]);
		            	 		/*if(res){
		            	 			scope.$watch('peticion.analiticas['+res+'].resultado.resultado',function(newvalue,oldvalue){
			  		            		console.log("operacion mat", scope.item.analitica.operacionmat);
	   		            			},true)
		      					}*/

	            	 		}

	            	 		scope.generarWatches();
	            	 	}


	            		ResultadosService.getOperacionMat(scope.item.peticion_id,scope.item.analitica_id,function(data){
			            	scope.devolucion = data;
			            	if(scope.item.analitica.operacionmat && (!ngModel.$viewValue ||ngModel.$viewValue=='')){
			            		//console.log(data);
		            			if(data.resultado){
		            				ngModel.$setViewValue(data.resultado);
	                				ngModel.$render();
			            		}
			            	}
			            	scope.revisarKeys(data.keys);
			            });
		            });
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();